import React from 'react'

export default function Calendar() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                d="M7.99961 8.7198H11.5552V12.3198H7.99961V8.7198ZM12.9774 2.2398H12.2663V0.799805H10.8441V2.2398H5.15517V0.799805H3.73294V2.2398H3.02183C2.23961 2.2398 1.59961 2.8878 1.59961 3.6798V13.7598C1.59961 14.5518 2.23961 15.1998 3.02183 15.1998H12.9774C13.7596 15.1998 14.3996 14.5518 14.3996 13.7598V3.6798C14.3996 2.8878 13.7596 2.2398 12.9774 2.2398ZM12.9774 3.6798V5.1198H3.02183V3.6798H12.9774ZM3.02183 13.7598V6.5598H12.9774V13.7598H3.02183Z"
                fill="#2F3237"
            />
        </svg>
    )
}
